import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ModuleState, PageState} from './vorlage-auswaehlen.reducer';
import {ListInputItem} from '../../../shared/sopi-list/sopi-list.model';
import {IncidentVorlageDetail} from '../../../../clients/incidents';

/**
 * The createFeatureSelector function selects a piece of state from the root of the state object.
 * This is used for selecting feature states that are loaded eagerly or lazily.
 */
export const getModuleState = createFeatureSelector<ModuleState>('VorlageAuswaehlenPage');

export const getPageState = createSelector(getModuleState, (state: ModuleState) => state.page);

// DATA
export const getVorlagen = createSelector(getPageState, (state: PageState) => state.vorlagen);
export const getVorlagenLaden = createSelector(getPageState, (state: PageState) => state.vorlagenLaden);
export const getVorlagenFehler = createSelector(getPageState, (state: PageState) => state.vorlagenFehler);

export const getVorlagenSopiList = createSelector(getPageState, (state: PageState) => {
    const retListe: Array<ListInputItem> = [];

    if (state.vorlagen === null) {
        return [];
    }

    state.vorlagen.map((item: IncidentVorlageDetail) => {
        retListe.push(<ListInputItem>{
            groupId: null,
            groupTitle: null,
            itemId: item.incident_vorlage_id,
            itemTitle: item.titel,
            item: item
        });
    });

    return retListe;
});

